import React from "react";
import dayjs from "dayjs";
import { DownloadOutlined, ExportOutlined } from '@ant-design/icons';
import { Image, Col, Space, Layout, Row, Spin, Tag, Popover } from "antd";
import { Button, Selector } from 'antd-mobile'
import { List as ListAntd } from "antd";
import { GET } from "../frameworks/HttpClient";
import { URL_DELIVERY, URL_REPORT, URL_GEOGRAPHY } from "../constants/urls";
import { GeographyLayer, THAI_LOCATION } from "../constants/string";
import ErrorMessages from "../components/common/ErrorMessages";
import { useParams } from "react-router-dom";
import { MapContainer, Marker, Popup, Polygon, LayerGroup, useMapEvents, GeoJSON } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-markercluster";
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-geosearch/dist/geosearch.css';
import "../App.css"
import * as _ from 'lodash';
import { Content, Footer } from "antd/es/layout/layout";
import LayerControl from "../components/map/layers/LayerControl";
import { SIMarkerIcon } from "../components/map/layers/icons/MarkerIcon";
delete L.Icon.Default.prototype._getIconUrl;


export default function ShippingInfomationScreen() {
  const SHOW_POLYGON_ON_ZOOM_LEVEL = 13

  const params = useParams();
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(null);
  const [siCode, setSiCode] = React.useState([]);
  const [plantation, setPlantation] = React.useState([]);
  const [plantationGroup, setPlantationGroup] = React.useState([]);
  const [geoLayers, setGeoLayers] = React.useState([]);
  const [deForestLayer, setDeforestLayer] = React.useState([]);
  const [nationalForestLayer, setNationalForestLayer] = React.useState([]);
  const [protectedAreaLayer, setProtectedAreaLayer] = React.useState([]);
  const [forestCoverLayer, setForestCoverLayer] = React.useState([]);
  const [reservedForestLayer, setReservedForestLayer] = React.useState([]);
  const [nonHuntingLayer, setNonHuntingLayer] = React.useState([]);
  const [geojsonBEUrl, setGeoJSONBEUrl] = React.useState(null)
  const [geoJSONBlob, setGeoJSONBlob] = React.useState(null)
  const mapRef = React.useRef();
  const [Zoom, setZoom] = React.useState(9);

  const GEOGRAPHY_LAYER_KEY = "area"
  const PLANTATION_LAYER_OPTIONS = [
    { 
      key: GeographyLayer.Types.DE_FOREST, 
      value: GeographyLayer.Types.DE_FOREST, 
      label: (
        <Popover content={
          <div>
            <div style={{fontWeight: "bold"}}>Data set details: Forest Change</div>
            <div>
              Results from time series analysis of Landsat images to classify the extent and change of
              Forests around the world from 2020 to 2023 using Landsat 8 OLI for 2020 onwards and Landsat 9 OLI
              For the year 2022 onwards, with reference to strip photos multispectral with composite imagery in the band
              4 spectral bands for Landsat spectral bands red, NIR, SWIR1, and SWIR2 (Landsat 8/9 bands 4, 5,
              6, and 7). and adjust Normalized top-of-atmosphere (TOA) reflectance values ​​(ρ) 8-bit data scale and have
              The spatial resolution is approximately 30 meters per pixel. For more information on these results, see
              More information can be found in the relevant journal (Hansen et al., Science 2013).
            </div>
            <br />
            <div style={{fontWeight: "bold"}}>Citations:</div>
            <div>- Source: Hansen/UMD/Google/USGS/NASA</div>
            <div>
              - Hansen, M. C., P. V. Potapov, R. Moore, M. Hancher, S. A. Turubanova, A. Tyukavina, D. Thau,
              S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice,
              and J. R. G. Townshend. 2013. "High-Resolution Global Maps of 21st-Century Forest Cover
              Change." Science 342 (15 November): 850-53. 10.1126/science.1244693
            </div>
          </div>
        }>
          <Tag color={GeographyLayer.Colors.DE_FOREST} style={{margin: 0}}>
            EU Deforestation
          </Tag>
        </Popover>
      )
    },
    { 
      key: GeographyLayer.Types.NATIONAL_PARK, 
      value: GeographyLayer.Types.NATIONAL_PARK, 
      label: (
        <Tag color={GeographyLayer.Colors.NATIONAL_PARK} style={{margin: 0}}>
          National Park
        </Tag>
      )
    },
    { 
      key: GeographyLayer.Types.NON_HUNTING, 
      value: GeographyLayer.Types.NON_HUNTING, 
      label: (
        <Tag color={GeographyLayer.Colors.NON_HUNTING} style={{margin: 0}}>
          Non Hunting
        </Tag>
      )
    },
    {
      key: GeographyLayer.Types.PROTECTED_AREA,
      value: GeographyLayer.Types.PROTECTED_AREA,
      label: (
        <Tag color={GeographyLayer.Colors.PROTECTED_AREA} style={{ margin: 0 }}>
          Protected Area
        </Tag>
      )
    },
    {
      key: GeographyLayer.Types.FOREST_COVER,
      value: GeographyLayer.Types.FOREST_COVER,
      label: (
        <Tag color={GeographyLayer.Colors.FOREST_COVER} style={{ margin: 0 }}>
          Forest Cover
        </Tag>
      )
    },
    {
      key: GeographyLayer.Types.RESERVED_FOREST,
      value: GeographyLayer.Types.RESERVED_FOREST,
      label: (
        <Tag color={GeographyLayer.Colors.RESERVED_FOREST} style={{ margin: 0 }}>
          Reserved Forest
        </Tag>
      )
    },
  ]

  const MapEvents = () => {
    useMapEvents({
      zoomend() {
        setZoom(mapRef.current.getZoom());
      },
    });
    return false;
  };

  const prepareGeoJSON = () => new Promise((resolve, reject) => {
    GET(`${URL_DELIVERY.PLANTATION_GEOJSON}${params.id}/`, { format: 'json' }, false, true)
      .then(resp => {
        setGeoJSONBEUrl(resp.requestUrl)
        setGeoJSONBlob(URL.createObjectURL(resp.data))
        resolve()
      })
      .catch((err) => reject(err))
  })

  const fetchData = async () => {
    try {
      setIsLoading(true)
      const response = await Promise.all([
        GET(`${URL_DELIVERY.PUBLIC_SHIPPING_INSTRUCTION}${params.id}/`),
        GET(`${URL_DELIVERY.PLANTATIONS_SOURCE_SI_TRACKING}${params.id}`),
        prepareGeoJSON()
      ])
      setSiCode(response[0].data)
      setPlantation(response[1].data.results)
      setPlantationGroup(
        Object.groupBy(response[1].data.results, (item) =>
          item.plantation.sub_district_id
        )
      )
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally { setIsLoading(false) }
  }

  const fetchGeographicLayer = async (layerType, params, callbackFunc) => {
    try {
      setIsLoading(true)
      const response = await GET(`${URL_GEOGRAPHY.LAYER_DETAIL}${layerType}/`, params)
      const results = response.data.results.flatMap(layer => JSON.parse(layer?.polygons)).filter(l => l)
      callbackFunc(results)
    }
    catch (error) {
      setErrorMessages(error.errorMessages);
    }
    finally {
      setIsLoading(false)
    }
  }

  const renderGeographyLayer = (item, type) => <GeoJSON style={{ color: GeographyLayer.Colors[type] }} data={item}/>
  const renderPlantationPolygons = (item) => {
    const data = item.polygons.map((polygon) => {
      return polygon.polygon.map((obj) => [obj.latitude, obj.longitude])
    })
    
    return (
      (Zoom >= SHOW_POLYGON_ON_ZOOM_LEVEL) && 
        <LayerGroup>
          <Polygon positions={data}/>
        </LayerGroup>
    )
    
  }

  const handleDownloadReportDDR = async (url) => {
    try {
      setIsLoading(true)
      const response = await GET(`${url}?si=${params.id}`);
      window.open(response.requestUrl, '_blank');
    } catch (error) {
      setErrorMessages('Error loading DRR Report', error);
    } finally {
      setIsLoading(false)
    }
  }

  const handleDownloadReportDeclaration = async (url) => {
    try {
      setIsLoading(true)
      const response = await GET(`${url}?si=${params.id}`);
      window.open(response.requestUrl, '_blank');
    } catch (error) {
      setErrorMessages('Error loading Traceability Declaration Report', error);
    } finally {
      setIsLoading(false)
    }
  }

  const cardStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const createClusterCustomIcon = function (cluster) {
    return L.divIcon({
      html: `<span>${cluster.getChildCount()}</span>`,
      className: 'marker-cluster-custom',
      iconSize: L.point(40, 40, true),
    });
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  React.useEffect(() => {
    geoLayers.includes(GeographyLayer.Types.DE_FOREST) ? fetchGeographicLayer(
      GeographyLayer.Types.DE_FOREST,
      { si: params.id }, 
      setDeforestLayer
    ) : setDeforestLayer([])

    geoLayers.includes(GeographyLayer.Types.NATIONAL_PARK) ? fetchGeographicLayer(
      GeographyLayer.Types.NATIONAL_PARK,
      { },
      setNationalForestLayer
    ) : setNationalForestLayer([])

    geoLayers.includes(GeographyLayer.Types.NON_HUNTING) ? fetchGeographicLayer(
      GeographyLayer.Types.NON_HUNTING,
      { si: params.id },
      setNonHuntingLayer
    ) : setNonHuntingLayer([])

    geoLayers.includes(GeographyLayer.Types.PROTECTED_AREA) ? fetchGeographicLayer(
      GeographyLayer.Types.PROTECTED_AREA,
      { si: params.id },
      setProtectedAreaLayer
    ) : setProtectedAreaLayer([])

    geoLayers.includes(GeographyLayer.Types.FOREST_COVER) ? fetchGeographicLayer(
      GeographyLayer.Types.FOREST_COVER,
      { si: params.id },
      setForestCoverLayer
    ) : setForestCoverLayer([])

    geoLayers.includes(GeographyLayer.Types.RESERVED_FOREST) ? fetchGeographicLayer(
      GeographyLayer.Types.RESERVED_FOREST,
      { si: params.id },
      setReservedForestLayer
    ) : setReservedForestLayer([])
  }, [geoLayers])

  return (
    <Layout>
      <Content>
    <Space
      direction="vertical"
      style={{ width: '100%' }}
      size={[0, 48]}>
      <Spin spinning={isLoading}>
        <Layout>
          <div style={{ textAlign: 'center' }}>
            <br />
            <Image
              style={{ textAlign: 'center', width: "100%", maxWidth: 120 }}
              preview={false}
              src={"/logo_txt.png"} />
          </div>
          <div style={{ textAlign: 'center' }}>
            <p>SI: {siCode.code} </p>
            <p>Factory: {siCode.factory_name}</p>
            <p>License Code: {siCode.factory_license_number}</p>
            <p>Product : {siCode.finish_product}</p>
          </div>
          
          <Row style={{marginRight: 24, marginLeft: 24}}>
            <Col span={24}>
              <ErrorMessages message={errorMessages} style={{ marginBottom: 8 }} />
              <Row gutter={[8, 8]} justify={"center"} style={{marginBottom: 16}}>
                <Col>
                  <Button color='primary' fill='outline' onClick={() => { window.open(geojsonBEUrl, '_blank') }}>
                    <ExportOutlined />
                    View GeoJSON
                  </Button>
                </Col>
                <Col>
                  <a href={geoJSONBlob} download={`${siCode?.code || 'polygons'}.geojson`}>
                    <Button color='primary' fill='outline'>
                      <DownloadOutlined />
                      Download GeoJSON
                    </Button>
                  </a>
                </Col>
                <Col>
                    <Button color='primary' fill='outline' onClick={() => handleDownloadReportDDR(URL_REPORT.DDR_REPORT)}>
                    <DownloadOutlined />
                    DDR (Summary)
                  </Button>
                </Col>
                <Col>
                    <Button color='primary' fill='outline' onClick={() => handleDownloadReportDDR(URL_REPORT.DDR_SMPT_1_REPORT)}>
                    <DownloadOutlined />
                    DDR (1)
                  </Button>
                </Col>
                <Col>
                  <Button color='primary' fill='outline' onClick={() => handleDownloadReportDDR(URL_REPORT.DDR_SMPT_2_REPORT)}>
                    <DownloadOutlined />
                    DDR (2)
                  </Button>
                </Col>
                <Col>
                  <Button color='primary' fill='outline' onClick={() => handleDownloadReportDeclaration(URL_REPORT.TRACEABILLITY_DECLARATION_REPORT)}>
                    <DownloadOutlined />
                    Declaration
                  </Button>
                </Col>
                {
                  siCode.dds_attachment != null &&
                  <Col>
                      <Button color='primary' fill='outline' onClick={() => window.open(siCode.dds_attachment, '_blank').focus()}>
                      <ExportOutlined />
                      DDS
                    </Button>
                  </Col>
                }
                {
                  siCode.legal_methodology_file != null &&
                  <Col>
                      <Button color='primary' fill='outline' onClick={() => window.open(siCode.legal_methodology_file, '_blank').focus()}>
                      <ExportOutlined />
                      Legal Methodology
                    </Button>
                  </Col>
                }
                {
                  siCode.delivery_handbook_file != null &&
                  <Col>
                    <Button color='primary' fill='outline' onClick={() => window.open(siCode.delivery_handbook_file, '_blank').focus()}>
                      <ExportOutlined />
                      Handbook
                    </Button>
                  </Col>
                }
              </Row>
              
              <Row gutter={[8, 8]} justify={"center"} style={{marginBottom: 16}}>
                <Selector 
                  multiple 
                  options={PLANTATION_LAYER_OPTIONS}
                  onChange={arr => setGeoLayers(arr)}/>
              </Row>
              
              <div style={{...cardStyle, marginBottom: 16}}>
                <div style={{ height: 700, width: "100%" }}>
                  <MapContainer ref={mapRef} zoom={5} maxZoom={20} minZoom={5} center={THAI_LOCATION} attributionControl={false} >
                    <MapEvents />
                    <LayerControl/>

                    <>
                      <ListAntd dataSource={plantation} renderItem={renderPlantationPolygons}/>
                      {deForestLayer.map(item => renderGeographyLayer(item, GeographyLayer.Types.DE_FOREST))}
                      {nationalForestLayer.map(item => renderGeographyLayer(item, GeographyLayer.Types.NATIONAL_PARK))}
                      {nonHuntingLayer.map(item => renderGeographyLayer(item, GeographyLayer.Types.NON_HUNTING))}
                      {protectedAreaLayer.map(item => renderGeographyLayer(item, GeographyLayer.Types.PROTECTED_AREA))}
                      {forestCoverLayer.map(item => renderGeographyLayer(item, GeographyLayer.Types.FOREST_COVER))}
                      {reservedForestLayer.map(item => renderGeographyLayer(item, GeographyLayer.Types.RESERVED_FOREST))}
                    </>

                    {
                      Object.entries(plantationGroup).map(([_, plantations]) => (
                        <MarkerClusterGroup
                          showCoverageOnHover={true}
                          spiderfyDistanceMultiplier={2}
                          iconCreateFunction={createClusterCustomIcon}
                          singleMarkerMode={false}
                        >
                          {plantations.map(item => {
                            return item.plantation.location ? (
                              <Marker
                                position={[item.plantation.location.latitude, item.plantation.location.longitude]}
                                icon={SIMarkerIcon}>
                                <Popup>{`[${item.plantation.code}]`}<br />{item.plantation.sub_district_detail}</Popup>
                              </Marker>
                            ) : <></>
                          })}
                        </MarkerClusterGroup>
                      ))
                    }
                  </MapContainer>
                </div>
              </div>
            </Col>
          </Row>
        </Layout>
      </Spin>
    </Space>
    </Content>

      <Footer style={{ textAlign: 'center' }}>
        Copyright © {dayjs().year()} MTI Solution. All rights reserved.
      </Footer>
    </Layout>
  )
}


